<template>
  <div class="new_vip">
    <div
      class="content"
      v-loading="tableLoading"
      element-loading-text="正在查询..."
    >
      <div class="options">
        <div class="options_item">
          会员手机号
          <el-input
            style="width:180px"
            v-model="params.mobile"
            class="input_box"
            size="small"
          ></el-input>
        </div>
        <div class="options_item">
          <el-button type="primary" size="small" @click="searchMobile()"
            >查询</el-button
          >
        </div>
        <div class="options_item">
          <el-button size="small" @click="showSearchBox = true"
            >高级查询</el-button
          >
        </div>
        <!-- <div class="options_item">
          <el-button size="small" @click="exportList()">导出</el-button>
        </div>
        <div class="options_item">
          <el-button size="small">打印</el-button>
        </div>
        <div class="options_item">
          <el-button size="small" @click="gotoImport()">导入</el-button>
        </div> -->
      </div>
      <div class="stat_box" v-if="userlist_count">
        <div
          class="stat_item_box stat_item_box_w"
          :class="{ stat_item_box_w1: statItems.cards.length }"
        >
          <div class="stat_item_title">会员总数</div>
          <div class="stat_item_value">
            {{ total || 0 }}
            <span>人</span>
          </div>
        </div>
        <!-- <div class="stat_item_box" v-if="false">
          <div class="stat_item_title">充值会员</div>
          <div class="stat_item_value">
            {{total}}
            <span>人</span>
          </div>
        </div> -->

        <div
          class="stat_item_box stat_item_box_w"
          :class="{ stat_item_box_w2: statItems.cards.length }"
        >
          <div class="stat_item_title">
            剩余余额
            <span class="title_total" v-if="statItems.cards.length">
              总计：{{ statItems.cardAll || 0 }}元
            </span>
          </div>
          <div class="stat_item_value" v-if="statItems.cards.length == 0">
            {{ statItems.balance || 0 }}
            <span>元</span>
          </div>
          <div class="stat_item_cards" v-else>
            <div class="cards_item_box">
              <div class="stat_item_cards_name">会员卡</div>
              <div class="stat_item_cards_value">
                {{ statItems.balance || 0 }}<span>元</span>
              </div>
            </div>
            <div
              class="cards_item_box"
              v-for="item in statItems.cards"
              :key="item.id"
            >
              <div class="stat_item_cards_name">{{ item.name }}</div>
              <div class="stat_item_cards_value">
                {{ item.count.balance || 0 }}<span>元</span>
              </div>
              <div class="card_part_line"></div>
            </div>
          </div>
        </div>
        <div
          class="stat_item_box stat_item_box_w"
          :class="{ stat_item_box_w1: statItems.cards.length }"
        >
          <div class="stat_item_title">积分统计</div>
          <div class="stat_item_value">
            {{ statItems.point || 0 }}
            <span>分</span>
          </div>
        </div>
      </div>
      <!-- 筛选项 -->
      <div style="margin:10px 0;">
        <el-radio-group v-model="screen" size="small" @change="getData">
          <el-radio-button label="1">今天</el-radio-button>
          <el-radio-button label="2">昨天</el-radio-button>
          <el-radio-button label="7">最近7天</el-radio-button>
          <el-radio-button label="z">自定义</el-radio-button>
          <!-- <el-radio-button v-for="item in paymentOptions" :key="item.value" :label="item.value">{{item.name}}</el-radio-button> -->
        </el-radio-group>
        <el-date-picker
          v-model="dateValue[0]"
          size="small"
          type="date"
          class="date_picker_box"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          :disabled="screen != 'z'"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="timeValue[0]"
          size="small"
          :disabled="screen != 'z'"
          class="date_picker_box"
          format="HH:mm"
          value-format="HH:mm"
          arrow-control
        ></el-time-picker>
        <span style="margin-right:8px">至</span>
        <el-date-picker
          v-model="dateValue[1]"
          size="small"
          type="date"
          class="date_picker_box"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :disabled="screen != 'z'"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="timeValue[1]"
          size="small"
          class="date_picker_box"
          :disabled="screen != 'z'"
          format="HH:mm"
          value-format="HH:mm"
          arrow-control
        ></el-time-picker>
        <el-button
          size="small"
          type="primary"
          v-show="screen == 'z'"
          @click="timeSearch()"
          >搜索</el-button
        >
        <span>几天未消费：</span>
        <el-input
          size="small"
          placeholder="天数"
          v-model="no_custom_days"
          type="number"
          min="0"
          style="width: 180px;"
        >
          <el-button slot="append" @click="getData">搜索</el-button>
        </el-input>
        <el-button
          v-if="userlist_check"
          style="margin-left: 10px"
          type="danger"
          size="small"
          @click="ISstatistics"
          v-text="statistics_type == 1 ? '关闭统计' : '查看统计'"
          >查看统计</el-button
        >
      </div>
      <div class="button_line">
        <div class="button_left">
          <el-button type="primary" size="small" @click="editItems()"
            >修改</el-button
          >
          <el-button size="small" @click="showDelUser = true"
            >删除会员</el-button
          >
          <!-- <el-button size="small">加油消费</el-button>
          <el-button size="small">快速消费</el-button> -->
          <el-button size="small" @click="editAccount(1)" v-if="app_id != '432'"
            >会员充值</el-button
          >
          <el-button size="small" @click="setUserTag()">会员标签</el-button>
          <!-- <el-button size="small">挂失锁定</el-button>
          <el-button size="small">会员延期</el-button> -->
          <el-button size="small" @click="editAccount(2)">积分调整</el-button>
          <!-- <el-button size="small">修改密码</el-button> -->
          <el-button size="small" @click="openChangeLevel()"
            >会员调级</el-button
          >
          <el-button size="small">发送短信</el-button>
          <el-button size="small" @click="sendCouponFrom()"
            >发送优惠券</el-button
          >
        </div>
        <div class="button_right">
          <el-popover placement="bottom" width="120" trigger="click">
            <el-checkbox
              style="margin-bottom:10px"
              v-for="(item, index) in showTableItems"
              :key="index"
              v-model="item.show"
              >{{ item.name }}</el-checkbox
            >
            <el-button
              slot="reference"
              size="small"
              icon="el-icon-s-unfold"
            ></el-button>
          </el-popover>
        </div>
      </div>
      <div class="table_content">
        <el-table
          ref="multipleTable"
          :data="tableData"
          :show-summary="showSum"
          :summary-method="getSummaries"
          @sort-change="sortData"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection" width="63"></el-table-column>
          <el-table-column
            label="卡号"
            prop="card_num"
            v-if="showTableItems[0].show"
          ></el-table-column>
          <el-table-column
            label="开卡时间"
            prop="create_time"
          ></el-table-column>
          <!-- <el-table-column label="卡面号" prop="number" v-if="showTableItems[1].show"></el-table-column> -->
          <el-table-column
            label="姓名"
            prop="real_name"
            v-if="showTableItems[1].show"
          >
            <template slot-scope="scope">
              <div>
                <el-button type="text" @click="rowClick(scope.row.uid)">{{
                  scope.row.real_name
                }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="等级"
            prop="card_level"
            v-if="showTableItems[2].show"
          ></el-table-column>
          <el-table-column label="头像" v-if="showTableItems[3].show">
            <template slot-scope="scope">
              <div class="headimg">
                <img :src="scope.row.headimgurl" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="性别"
            prop="show_sex"
            v-if="showTableItems[4].show"
          ></el-table-column>
          <el-table-column
            label="手机"
            prop="mobile"
            v-if="showTableItems[5].show"
            min-width="106px"
          >
            <template slot-scope="scope">
              <div>
                <el-button type="text" @click="rowClick(scope.row.uid)">{{
                  scope.row.mobile
                }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="余额"
            prop="show_balance"
            v-if="showTableItems[6].show && statistics_type == 1"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            label="积分"
            prop="point"
            v-if="showTableItems[7].show && statistics_type == 1"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            label="累计消费"
            prop="total_custom"
            v-if="showTableItems[8].show && statistics_type == 1"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            label="累计积分"
            prop="total_point"
            v-if="showTableItems[9].show && statistics_type == 1"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            label="消费次数"
            prop="custom_num"
            v-if="showTableItems[10].show && statistics_type == 1"
            sortable="custom"
          ></el-table-column>
          <!-- <el-table-column label="累计消费" prop="total_custom" v-if="showTableItems[8].show"></el-table-column>
          <el-table-column label="累计积分" prop="total_point" v-if="showTableItems[9].show"></el-table-column> -->
          <el-table-column
            label="所属分店"
            prop="shop"
            v-if="showTableItems[11].show"
          ></el-table-column>
          <!-- <el-table-column label="车辆信息" v-if="showTableItems[12].show">
            <template slot-scope="scope">
              <el-button type="text" @click="showCarMsg(scope.row.id)"
                >查看</el-button
              >
            </template>
          </el-table-column> -->
          <el-table-column
            label="车牌号"
            v-if="showTableItems[12].show"
            prop="plate"
          ></el-table-column>
          <el-table-column label="开票信息" v-if="showTableItems[13].show">
            <template slot-scope="scope">
              <el-button type="text" @click="showInvoiceMsg(scope.row.id)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
            v-if="showTableItems[14].show"
          ></el-table-column>
          <el-table-column
            label="剩余时间"
            prop="show_end_time"
            v-if="showTableItems[15].show"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="Cashier(scope.row)"
                >收银支付</el-button
              >
              <el-button type="text" @click="addDesc(scope.row)"
                >添加备注</el-button
              >
            </template>
          </el-table-column>
          <!-- <el-table-column label="消费记录" v-if="showTableItems[14].show" width="150px">
            <template slot-scope="scope">
              <el-button type="text" @click="showOrderMsg(scope.row.uid)">油品订单</el-button>
              <el-button type="text" @click="showVoucherMsg(scope.row.uid)">充值订单</el-button>
            </template>
          </el-table-column> -->
          <!-- <el-table-column width="70px;">
            <template slot="header">
              <el-popover
                placement="bottom"
                width="120"
                trigger="click">
                <el-checkbox style="margin-bottom:10px" v-for="(item,index) in showTableItems" :key="index" v-model="item.show">{{item.name}}</el-checkbox>
                <el-button slot="reference" size="small" icon="el-icon-s-unfold"></el-button>
              </el-popover>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 高级查询弹窗 -->
    <el-dialog
      :visible.sync="showSearchBox"
      @close="showSearchBox = false"
      title="高级查询"
      width="700px"
    >
      <el-form :model="searchForm" label-width="106px">
        <el-form-item label="会员姓名" class="search_form_item">
          <el-input
            size="small"
            v-model="searchForm.name"
            class="search_input"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="生日月份" class="search_form_item">
          <el-select v-model="searchForm.month" placeholder="请选择" class="search_input" size="small">
            <el-option
              v-for="(index) in 12"
              :key="index"
              :label="index+'月'"
              :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开卡分店" class="search_form_item">
          <el-select v-model="searchForm.store_id" placeholder="请选择" class="search_input" size="small">
            <el-option
              v-for="item in store_options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开卡操作员" class="search_form_item">
          <el-select v-model="searchForm.emp_id" placeholder="请选择" class="search_input" size="small">
            <el-option
              v-for="item in emp_options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="会员等级" class="search_form_item">
          <!-- <el-select v-model="searchForm.user_level_id" placeholder="请选择" class="search_input" size="small">
            <el-option
              v-for="item in level_options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select> -->
          <el-cascader
            v-model="searchForm.user_level_id"
            placeholder="请选择"
            class="search_input"
            :options="level_options"
            :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'id',
              children: 'lists',
            }"
            clearable
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="会员卡号" class="search_form_item">
          <!-- <el-select v-model="searchForm.status" placeholder="请选择" class="search_input" size="small">
            <el-option>所有会员</el-option>
          </el-select> -->
          <el-input
            size="small"
            class="search_input"
            v-model="searchForm.card_num"
          ></el-input>
        </el-form-item>
        <el-form-item label="实体卡号" class="search_form_item">
          <el-input
            size="small"
            class="search_input"
            v-model="searchForm.physical_card"
          ></el-input>
        </el-form-item>
        <el-form-item label="车牌号" class="search_form_item">
          <el-input
            size="small"
            class="search_input"
            v-model="searchForm.plate"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="会员性别" class="search_form_item">
          <el-select clearable v-model="searchForm.sex" placeholder="请选择" class="search_input" size="small">
            <el-option :value="'1'" label="男"></el-option>
            <el-option :value="'2'" label="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号" class="search_form_item">
          <el-input size="small" class="search_input" v-model="searchForm.carNum"></el-input>
        </el-form-item>
        <el-form-item label="积分数量" class="search_form_item">
          <el-input size="small" class="search_input" v-model="searchForm.point"></el-input>
        </el-form-item>
        <el-form-item label="账户余额" class="search_form_item">
          <el-input size="small" class="search_input" v-model="searchForm.balance"></el-input>
        </el-form-item>
        <el-form-item label="累计消费金额" class="search_form_item">
          <el-input size="small" class="search_input" v-model="searchForm.allPay"></el-input>
        </el-form-item>
        <el-form-item label="累计充值金额" class="search_form_item">
          <el-input size="small" class="search_input" v-model="searchForm.allAccount"></el-input>
        </el-form-item>
        <el-form-item label="开卡时间" class="search_form_item">
          <el-date-picker
            v-model="searchForm.openTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width: 214px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="到期时间" class="search_form_item">
          <el-date-picker
            v-model="searchForm.endTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width: 214px;">
          </el-date-picker>
        </el-form-item> -->
      </el-form>
      <div class="search_button">
        <el-button type="primary" @click="search()">查询</el-button>
        <el-button @click="showSearchBox = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 用户车辆信息弹窗 -->
    <el-dialog
      :visible.sync="showCarDetail"
      @close="closeCarDetail"
      title="车辆信息"
      width="600px"
    >
      <div class="car_msg_box">
        <div class="car_msg_item">车牌号：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">常用油品：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">汽车排量：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">汽车品牌：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">车系(车型)：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">车辆购买时间：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">保险到期时间：{{ carDetail.car_num }}</div>
      </div>
    </el-dialog>
    <!-- 用户开票信息弹窗 -->
    <el-dialog
      :visible.sync="showInvoiceDetail"
      @close="closeInvoiceDetail"
      title="开票信息"
      width="600px"
    >
      <div class="car_msg_box">
        <div class="car_msg_item">发票类型：{{ InvoiceDetail.type }}</div>
        <div class="car_msg_item">发票抬头：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">税号：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">邮箱地址：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">开户银行：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">银行账号：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">电话号码：{{ InvoiceDetail.car_num }}</div>
      </div>
    </el-dialog>
    <!-- 发送优惠券弹窗 -->
    <el-dialog
      :visible.sync="showSendCoupon"
      title="发送优惠券"
      @close="closeSend"
      width="700px"
    >
      <!-- 选择发布方式 -->
      <div>
        <div class="" style="text-align:center">
          <span>发送方式：</span>
          <el-radio v-model="CouponType" label="1">多券发布</el-radio>
          <el-radio v-model="CouponType" label="2">单券多张</el-radio>
        </div>
      </div>
      <!-- 多卷发布 -->
      <div class="single" v-if="CouponType == '1'">
        <el-form label-width="90px" size="">
          <el-form-item label="发送给" style="margin-bottom:0">
            {{ sendCouponUserName }}
            <!-- {{selectUserName}}
            <el-button size="small" @click="showSelecterUser=true" :disabled="sendToAll">选择</el-button> -->
            <div>
              <el-checkbox v-model="sendToAll">全部用户</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item label="优惠券">
            <el-tag
              v-for="(tag, idx) in sList"
              :key="tag.id"
              closable
              @close="delTagItem(idx)"
              style="margin-bottom:5px;margin-right:5px;"
            >
              {{ tag.name }}
            </el-tag>
            <el-button size="small" @click="showSelecter = true"
              >选择</el-button
            >
          </el-form-item>
          <verificationCode  style="width:386px" v-model="code_num" v-if="sms_stats.open_sms_coupon == 1"></verificationCode>
          <!-- <el-form-item
            label="验证码"
            v-if="sms_stats.open_sms_coupon == 1"
            style="width:386px"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode"
                  type="primary"
                  >{{ code_text }}</el-link
                >
              </template>
            </el-input>
          </el-form-item> -->
        </el-form>
        <div style="text-align:center">
          <el-button type="primary" @click="clickSend()">发送</el-button>
          <el-button @click="closeSend()">取消</el-button>
        </div>
      </div>
      <!-- 单卷多张 -->
      <div class="single" v-if="CouponType == '2'">
        <el-form label-width="90px" size="">
          <el-form-item label="发送给" style="margin-bottom:0">
            {{ sendCouponUserName }}
            <!-- {{selectUserName}} -->
            <!-- <el-button size="small" @click="showSelecterUser=true" :disabled="sendToAll">选择</el-button> -->
            <div>
              <el-checkbox v-model="sendToAll">全部用户</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item label="优惠券" style="margin-bottom:5px">
            <el-tag
              v-if="couponOne.id != ''"
              :key="couponOne.id"
              style="margin-bottom:5px;margin-right:5px;"
            >
              {{ couponOne.name }}
            </el-tag>
            <el-button size="small" @click="showSelecterOne = true"
              >选择</el-button
            >
          </el-form-item>
          <el-form-item label="每人送" style="margin-bottom:5px">
            <el-input
              v-model="everyoneNum"
              placeholder=""
              size="small"
              style="width:100px;margin-right:5px;"
            ></el-input
            >张
          </el-form-item>
          <verificationCode  style="width:386px" v-model="code_num" v-if="sms_stats.open_sms_coupon == 1"></verificationCode>
          <!-- <el-form-item
            label="验证码"
            v-if="sms_stats.open_sms_coupon == 1"
            style="width:386px"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode"
                  type="primary"
                  >{{ code_text }}</el-link
                >
              </template>
            </el-input>
          </el-form-item> -->
          <!-- <el-form-item label="">
            <el-checkbox v-model="timingSend">定时发送</el-checkbox>
          </el-form-item> -->
        </el-form>
        <div style="text-align:center">
          <el-button type="primary" @click="clickSend()">发送</el-button>
          <el-button @click="closeSend()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择用户弹窗 -->
    <el-dialog
      :visible.sync="showSelecterUser"
      @close="showSelecterUser = false"
    >
      <selectCommodity
        @close="showSelecterUser = false"
        @getCommod="getCommodUser"
        :sList="sUserList"
        :jude="4"
        :menuName="'会员'"
      ></selectCommodity>
    </el-dialog>
    <!-- 选择优惠券弹窗 -->
    <!-- 多张优惠券发送1张 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
        :menuName="'优惠券'"
      ></selectCommodity>
    </el-dialog>
    <!-- 单张优惠券发送多张 -->
    <el-dialog
      :visible.sync="showSelecterOne"
      @close="showSelecterOne = false"
      width="460px"
    >
      <selectCommodityOne
        @close="showSelecterOne = false"
        @getCommod="getCommodOne"
        :jude="2"
      ></selectCommodityOne>
    </el-dialog>
    <!-- 修改用户等级弹窗 -->
    <el-dialog
      :visible.sync="showChangeLevel"
      @close="closeChange"
      title="会员调级"
      width="600px"
    >
      <div>
        <el-form label-width="90px" size="">
          <el-form-item label="用户" style="margin-bottom:0">
            {{ sendCouponUserName }}
          </el-form-item>
          <el-form-item label="调级">
            <el-select
              v-model="change_level_id"
              placeholder="请选择"
              size="small"
            >
              <!-- <el-option
                v-for="item in level_options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option> -->
              <el-option-group
                v-for="group in level_options"
                :key="group.id"
                :label="group.name"
              >
                <el-option
                  v-for="item in group.lists"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <verificationCode  style="width:386px" v-model="code_num" v-if="sms_stats.open_update_level == 1"></verificationCode>
          <!-- <el-form-item
            label="验证码"
            v-if="sms_stats.open_update_level == 1"
            style="width:386px"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode"
                  type="primary"
                  >{{ code_text }}</el-link
                >
              </template>
            </el-input>
          </el-form-item> -->
        </el-form>
        <div style="text-align:center">
          <el-button type="primary" @click="clickChangeLevel()">确定</el-button>
          <el-button @click="closeChange()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 用户账户信息弹窗 -->
    <UserAccount
      :showAccount="showAccount"
      :accountData="accountData"
      @close="showAccount = false"
      @refresh="getData"
      :tabs="accountTabs"
    ></UserAccount>
    <!-- 用户油品订单 -->
    <el-dialog
      :visible.sync="showOrderList"
      @close="showOrderList = false"
      width="80%"
      title="油品订单"
    >
      <order-list :uid="user_id_order"></order-list>
    </el-dialog>
    <!-- 用户充值订单 -->
    <el-dialog
      :visible.sync="showVoucherList"
      @close="showVoucherList = false"
      width="80%"
      title="充值订单"
    >
      <voucher-list :uid="user_id_voucher"></voucher-list>
    </el-dialog>
    <!-- 单券多张发送进度 -->
    <el-dialog
      :visible.sync="showSendPro"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      title="发送优惠券"
      center
    >
      <div style="text-align:center">
        <div style="margin-bottom:20px">
          <el-progress type="circle" :percentage="sentPercent"></el-progress>
        </div>
        <div>
          <i class="el-icon-loading"></i> 正在发送优惠券，请勿关闭网页。
        </div>
      </div>
    </el-dialog>
    <!-- 修改用户信息 -->
    <el-dialog
      :visible.sync="showEditUser"
      @close="showEditUser = false"
      width="70%"
      title="修改会员信息"
    >
      <user-edit
        :type="'edit'"
        :editData="editData"
        @close="showEditUser = false"
        @refresh="getData()"
      ></user-edit>
    </el-dialog>
    <!-- 添加会员标签 -->
    <el-dialog
      :visible.sync="showUserTag"
      title="添加会员标签"
      @close="closeTag(0)"
      width="400px"
    >
      <user-tag :uid="selectUid" @closeTag="closeTag"></user-tag>
    </el-dialog>
    <el-dialog
      :visible.sync="showUserremark"
      title="编辑会员备注"
      destroy-on-close
      @close="showUserremark = false"
      width="400px"
    >
      <el-input v-model="remark" placeholder="请输入备注"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showUserremark = false">取 消</el-button>
        <el-button type="primary" @click="submit_remark">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showDelUser"
      title="会员删除"
      destroy-on-close
      @close="showDelUser = false"
      width="70%"
    >
      <div>
        <el-form label-width="120px" size="">
          <el-form-item label="删除条件选择" style="margin-bottom:0">
            <el-radio-group v-model="radio">
              <el-radio :label="1">按会员等级删除</el-radio>
              <el-radio :label="2">按会员手机号删除</el-radio>
              <el-radio :label="3">按未消费时间（天）删除</el-radio>
              <el-radio :label="4">自定义选择会员删除</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="会员等级" v-if="radio == 1">
            <el-cascader
              v-model="levelArrs"
              :options="level_options"
              :props="{
                expandTrigger: 'hover',
                value: 'id',
                label: 'name',
                children: 'lists',
              }"
              @change="handleLevelChange"
            ></el-cascader>
            <!-- <el-select
              style="width: 40%;"
              v-model="level_id"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in level_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="会员手机号" v-if="radio == 2">
            <el-input
              size="small"
              style="width: 30%;"
              v-model="vip_phone"
              placeholder="请输入会员手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="未消费时间（天）" v-if="radio == 3">
            <el-input
              size="small"
              style="width: 30%;"
              v-model="day"
              placeholder="请输入未消费时间（天）"
            ></el-input>
          </el-form-item>
          <el-form-item label="选择会员：" v-if="radio == 4">
            <div v-if="multipleSelection.length > 0">
              <span>{{ sendCouponUserName }}</span>
            </div>
            <div v-else>
              尚未选择会员，请关闭弹窗选择会员进行删除。也可选择其他模式删除！
            </div>
            <!-- <el-select
              style="width: 80%;"
              v-model="user_id"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in user_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <verificationCode v-model="code_num" v-if="sms_stats.open_delete_user == 1"></verificationCode>
          <!-- <el-form-item label="验证码" v-if="sms_stats.open_delete_user == 1">
            <el-input style="width: 30%;" class="input_box" v-model="code_num">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode"
                  type="primary"
                  >{{ code_text }}</el-link
                >
              </template>
            </el-input>
          </el-form-item> -->
        </el-form>
        <div>
          <div>提示：</div>
          <div>1.因会员卡只能领取一次，删除会员后用户无法再次注册为会员</div>
          <div>2.删除会员后不能恢复</div>
          <div>3.删除会员后订单无法显示用户信息</div>
          <div>请确认后慎重删除</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDelUser = false">取 消</el-button>
        <el-button type="primary" @click="submit_DelUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import selectCommodityOne from "@/components/commodity/selectCommodity2.vue";
import { mapGetters } from "vuex";
import { SendAdminCode, privacy } from "@/api/set";
import {
  changeUserLevel,
  employeeOptions,
  levelGroupSelect,
  sendCoupon,
  sendCouponS,
  vipstatistic_new,
  vipUserList,
  edit_vip_remark,
  delete_user,
} from "@/api/vip";
import { storeSelect } from "@/api/employee";
import UserAccount from "@/views/apply/vip/vipUserAccount";
import OrderList from "@/views/apply/newVip/order/oilsList";
import VoucherList from "@/views/apply/newVip/order/voucherList";
import UserEdit from "@/views/apply/newVip/home/openCard";
import UserTag from "@/components/vip/userTags";
import verificationCode from "@Components/verification/verificationCode"

export default {
  components: {
    UserAccount,
    selectCommodity,
    OrderList,
    VoucherList,
    selectCommodityOne,
    UserEdit,
    UserTag,
    verificationCode
  },
  computed: {
    ...mapGetters(["token", "app_id", "status"]),
  },
  data() {
    return {
      radio: 4,
      showDelUser: false,
      userlist_count: true,
      userlist_check: true,
      id: "",
      showUserremark: false,
      remark: "",
      code_num: "",
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      sms_stats: {},
      keyword: "", //会员手机号
      level_id: "", //会员等级id
      vip_phone: "", //会员手机号
      day: "", //会员未消费时间（天）
      user_ids: [], //会员id
      params: {
        //查询条件
        name: "", //会员姓名
        card_num: "", //会员卡号
        user_level_id: "", //会员等级id
        mobile: "", //手机号
      },
      store_options: [], //店铺选项
      level_options: [], //会员等级选项
      emp_options: [], //员工选项
      tableData: [], //表格数据
      multipleSelection: [], //表格选中项
      showTableItems: [
        { name: "卡号", show: true },
        { name: "姓名", show: true },
        { name: "等级", show: true },
        { name: "头像", show: false },
        { name: "性别", show: true },
        { name: "手机", show: true },
        { name: "余额", show: true },
        { name: "积分", show: true },
        { name: "累计消费", show: true },
        { name: "累计积分", show: true },
        { name: "消费次数", show: true },
        { name: "分店", show: false },
        { name: "车牌号", show: false },
        { name: "开票信息", show: false },
        { name: "备注", show: false },
        { name: "剩余时间", show: true },
        // {name: "消费记录",show: true},
      ], //表格显示内容
      page: 1, //页码
      total: 0, //总数
      showSearchBox: false, //显示高级查询窗口
      searchForm: {}, //高级查询表单
      showAccount: false, //显示修改账户弹窗
      accountData: {}, //用户账户信息
      accountTabs: "point", //充值类型 point:积分 balance:余额
      showSum: false, //显示统计行
      showCarDetail: false, //显示车辆信息
      carDetail: {}, //车辆信息
      showInvoiceDetail: false, //显示开票信息
      InvoiceDetail: {}, //开票信息
      sort: "0", //'0':正常，'1':按积分从大到小排序
      showSendCoupon: false, //显示发送优惠券弹窗
      sendCouponUserName: "", // 发送优惠券的用户名
      showSelecter: false, // 选择优惠券弹窗
      showSelecterOne: false, // 选择优惠券弹窗 单张
      couponOne: { id: "" }, //单张优惠券信息
      sList: [], //已选择优惠券列表
      showChangeLevel: false, //会员调级窗口
      change_level_id: "", //调整等级id
      showOrderList: false, //用户油品订单
      user_id_order: "", //查看订单用户id
      user_id_voucher: "", //查看充值用户id
      showVoucherList: false, //用户充值订单
      CouponType: "0", // 优惠券发布类型
      everyoneNum: "", //单券多张 张数
      timingSend: false, // 定时发送
      tableLoading: false, //表格loading
      selectUserName: "", //选择的用户名称
      showSelecterUser: false, //选择用户弹窗
      sUserList: [], //已选择用户
      sendToAll: false, //发送给全部用户
      showSendPro: false, //单券多张发送窗口
      sentPercent: 0, //单券多张发送进度
      showEditUser: false, //修改用户信息弹窗
      editData: {}, //修改会员表单信息
      statItems: {
        cards: [],
      }, //统计项
      showUserTag: false, // 用户标签弹窗
      selectUid: "", // 选择的用户uid
      screen: "", //筛选
      dateValue: [],
      timeValue: [],
      no_custom_days: "", //未消费天数
      statistics_type: 0,
      levelArrs: [],
    };
  },
  mounted() {
    this.getSetyinsi();
    this.init();
    this.getData();
    this.getconfig();
  },
  methods: {
    handleLevelChange(e) {
      console.log(e);
      this.level_id = e[1];
      console.log(this.level_id);
    },
    async submit_DelUser() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        verification_code: this.code_num,
      };
      if (this.radio == 1) {
        if (!this.level_id) {
          return this.$message({
            message: "请选择会员等级",
            type: "warning",
          });
        }
        data.user_level_id = this.level_id;
      }
      if (this.radio == 2) {
        if (!this.vip_phone) {
          return this.$message({
            message: "请输入会员手机号",
            type: "warning",
          });
        }
        data.mobile = this.vip_phone;
      }
      if (this.radio == 3) {
        if (!this.day) {
          return this.$message({
            message: "请输入未消费时间（天）",
            type: "warning",
          });
        }
        data.no_custom_days = this.day;
      }
      if (this.radio == 4) {
        if (this.multipleSelection.length == 0) {
          return this.$message({
            message: "请选择会员",
            type: "warning",
          });
        }
        data.uids = this.user_ids.join(",");
      }
      const res = await delete_user(data);
      if (res.code == 200) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.showDelUser = false;
        this.getData();
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async getSetyinsi() {
      const res = await privacy({ app_id: this.app_id });
      if (res.code == 200) {
        console.log(res);
        if (res.data) {
          this.userlist_count = Boolean(res.data.userlist_count);
          this.userlist_check = Boolean(res.data.userlist_count);
        }
      }
    },
    //编辑会员备注
    addDesc(row) {
      this.id = row.id;
      this.remark = row.remark;
      this.showUserremark = true;
    },
    async submit_remark() {
      let data = {
        id: this.id,
        app_id: this.app_id,
        remark: this.remark,
      };
      const res = await edit_vip_remark(data);
      if (res.code == 200) {
        this.$message.success("操作成功");
        this.showUserremark = false;
        this.getData();
      } else {
        this.$message.error(res.msg);
      }
    },
    Cashier(row) {
      console.log("收银按钮", row);
      sessionStorage.setItem("childRouter", "");
      sessionStorage.setItem("routerIdx", 0);
      this.$router.push({
        path: "/apply/newVip/13/business/getMoney",
        query: {
          mobile: row.mobile,
        },
      });
    },
    async getconfig() {
      this.sms_stats = await this.get_prosms_ob();
    },
    ISstatistics() {
      this.statistics_type = this.statistics_type == 1 ? 0 : 1;
      this.getData();
    },
    // 时间筛选
    timeSearch() {
      if (!this.dateValue[0]) {
        this.$message("未选择开始时间");
      } else if (!this.dateValue[1]) {
        this.$message("未选择结束时间");
      } else if (
        new Date(this.dateValue[0]).getTime() >
        new Date(this.dateValue[1]).getTime()
      ) {
        this.$message("开始时间不能大于结束时间");
      } else {
        this.getData(1);
      }
    },
    // 格式化时间戳
    formatDate(t) {
      var time = new Date(t);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      mm = mm < 10 ? "0" + mm : mm;
      return y + "-" + m + "-" + d + " " + h + ":" + mm;
    },
    formatTime(t, i) {
      //t:时间 i:格式化 1.截取到日期的00:00:00 2.截取到日期的23:59:59 3.截取到本月开始时间 4.截取到本年开始时间
      var time = this.formatDate(t);
      if (i == 1) {
        var rt = time.split(" ")[0] + " 00:00:00";
        return rt;
      } else if (i == 2) {
        var rt = time.split(" ")[0] + " 23:59:59";
        return rt;
      } else if (i == 3) {
        var rt = time.split("-")[0] + "-" + time.split("-")[1] + "-01 00:00:00";
        return rt;
      } else if (i == 4) {
        var rt = time.split("-")[0] + "-01-01 00:00:00";
        return rt;
      }
    },
    // 获取数据
    async getData() {
      this.tableLoading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        sorts: this.sort,
        statistics_type: this.statistics_type,
        // point_order: this.sort
      };
      console.log("this.params", this.params);
      if (this.params.mobile) {
        data.mobile = this.params.mobile;
      }
      if (this.params.name) {
        data.name = this.params.name;
      }
      if (this.params.card_num) {
        data.card_num = this.params.card_num;
      }
      if (this.params.user_level_id) {
        data.user_level_id = this.params.user_level_id[1];
      }
      if (this.params.plate) {
        data.plate = this.params.plate;
      }
      if (this.searchForm.physical_card) {
        data.physical_card = this.searchForm.physical_card;
      }
      // 時間篩選
      if (this.screen != "") {
        if (this.screen == "1") {
          data.start_time = this.formatTime(new Date(), 1);
          data.end_time = this.formatTime(new Date(), 2);
        }
        if (this.screen == "2") {
          let start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          data.start_time = this.formatTime(start, 1);
          data.end_time = this.formatTime(start, 2);
        }
        if (this.screen == "7") {
          let start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          data.start_time = this.formatTime(start, 1);
          data.end_time = this.formatTime(new Date(), 2);
        }
        if (this.screen == "z") {
          if (this.dateValue !== null && this.dateValue.length !== 0) {
            data.start_time = this.timeValue[0]
              ? this.dateValue[0] + " " + this.timeValue[0]
              : this.dateValue[0] + " 00:00:00";
            data.end_time = this.timeValue[1]
              ? this.dateValue[1] + " " + this.timeValue[1]
              : this.dateValue[1] + " 23:59:59";
          }
        }
      }
      if (this.no_custom_days != "") {
        data.no_custom_days = this.no_custom_days;
      }
      this.newstatistic(data);
      const res = await vipUserList(data);
      console.log(res);
      if (res.code == 200) {
        this.tableData = res.data.result;
        // this.statItems = Object.assign({},res.data.count);

        this.tableData.forEach((item) => {
          item.show_sex = item.sex == 1 ? "男" : item.sex == 2 ? "女" : "未知";
          // item.show_end_time = item.up_time == 0? "永久有效":"剩余"+item.up_time+"天"
          item.show_end_time = "永久有效";
          item.show_balance = (
            Number(item.balance) + Number(item.oil_card_balance)
          ).toFixed(2);
        });
        this.total = res.data.total_num;
        this.showSum = !!this.tableData.length;
      } else {
        this.$message(res.msg);
      }
      this.tableLoading = false;
    },
    // 初始化选择项
    //统计(新)
    async newstatistic(data) {
      const res = await vipstatistic_new(data);
      if (res.code == 200) {
        this.statItems.balance = res.data.count.balance;
        this.statItems.point = res.data.count.point;
        this.statItems.cards = res.data.count_oil;
        var a = Number(this.statItems.balance);
        console.log(this.statItems.cards.length);
        if (this.statItems.cards.length) {
          this.statItems.cards.forEach((item) => {
            a += Number(item.count.balance);
          });
          this.statItems.cardAll = a.toFixed(2);
        }
      }
    },
    init() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      if (this.$route.query.user_level) {
        this.searchForm.user_level_id = this.$route.query.user_level;
        this.search();
      }
      storeSelect(data).then((res) => {
        if (res.code == 200) {
          this.store_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取门店列表失败，请刷新重试"
          // })
        }
      });
      levelGroupSelect(data).then((res) => {
        if (res.code == 200) {
          this.level_options = res.data;
        } else {
        }
      });
      employeeOptions(data).then((res) => {
        if (res.code == 200) {
          this.emp_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取员工列表失败，请刷新重试"
          // })
        }
      });
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendMyCode();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 高级查询
    search() {
      console.log(this.searchForm);
      this.params.card_num = this.searchForm.card_num;
      this.params.user_level_id = this.searchForm.user_level_id;
      this.params.name = this.searchForm.name;
      this.params.plate = this.searchForm.plate;
      this.showSearchBox = false;
      this.page = 1;
      this.getData();
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
      this.sendCouponUserName =
        this.multipleSelection.map((n) => n.real_name).join(",") +
        " 共" +
        this.multipleSelection.length +
        "位用户";
      this.user_ids = this.multipleSelection.map((n) => n.uid);
      console.log(this.user_ids);
    },
    // 分页
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.getData();
    },
    // 会员修改
    editItems() {
      if (this.multipleSelection.length != 1) {
        this.$message("请选择一个用户操作");
      } else {
        var data = this.multipleSelection[0];
        // this.editData = {
        //   real_name: data.real_name,
        //   sex: data.sex,
        //   mobile: data.mobile,
        //   level_card_id: data.user_level_id,
        //   birthday: data.birthday,
        //   id: data.uid
        // };
        // this.showEditUser = true;
        this.$router.push({ path: "userDetail", query: { id: data.uid } });
      }
    },
    // 会员删除
    delItems() {
      var i = this.multipleSelection.map((x) => x.id).join(",");
      console.log(i);
      var title;
      this.$confirm("删除后无法恢复！确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: i,
          };
          // delList(data).then(res => {
          //   if (res.code == 200) {
          //     this.$message({
          //       type: "success",
          //       message: "删除成功"
          //     });
          //     this.getData();
          //   } else {
          //     this.$message({
          //       type: "error",
          //       message: res.msg
          //     });
          //   }
          // });
        })
        .catch();
    },
    // 会员充值 type: 1.余额，2.积分
    editAccount(type) {
      if (this.multipleSelection.length != 1) {
        this.$message("请选择一个用户操作");
      } else {
        this.accountData = {
          uid: this.multipleSelection[0].uid,
          balance: this.multipleSelection[0].balance,
          point: this.multipleSelection[0].point,
          card_id: this.multipleSelection[0].id,
        };
        // 联盟
        this.accountData.alliance = {
          point: this.multipleSelection[0].alliance_point,
          alliance: this.multipleSelection[0].alliance,
        };
        this.accountTabs = type == 1 ? "balance" : "point";
        this.showAccount = true;
        console.log("数据", this.accountData);
      }
    },
    // 自定义统计方法
    getSummaries(param) {
      console.log(param);
      if (param.data.length) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "总计:";
            return;
          }
          if (
            column.label == "积分" ||
            (column.label == "余额" && data.length)
          ) {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values
                .reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0)
                .toFixed(2);
            }
          }
        });
        return sums;
      }
    },
    // 会员导入
    gotoImport() {
      this.$router.push("/apply/newVip/13/center/import");
    },
    // 查看车辆信息
    showCarMsg(id) {
      console.log(id);
      this.showCarDetail = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: id,
      };
      // vipCarMsg(data).then(res => {
      //   if(res.code == 200){
      //     this.carDetail = res.data
      //   }else{
      //     this.$message(res.msg)
      //   }
      // })
    },
    // 关闭车辆信息
    closeCarDetail() {
      this.showCarDetail = false;
      this.carDetail = {};
    },
    // 查看开票信息
    showInvoiceMsg(id) {
      console.log(id);
      this.showInvoiceDetail = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: id,
      };
      // vipInvoiceMsg(data).then(res => {
      //   if(res.code == 200){
      //     this.invoiceDetail = res.data
      //   }else{
      //     this.$message(res.msg)
      //   }
      // })
    },
    // 关闭开票信息
    closeInvoiceDetail() {
      this.showInvoiceDetail = false;
      this.InvoiceDetail = {};
    },
    //自定义排序
    sortData(event) {
      console.log(event);
      if (event.order == "descending") {
        if (event.prop == "show_balance") {
          this.sort = "balance_desc";
        } else if (event.prop == "point") {
          this.sort = "point_desc";
        } else if (event.prop == "total_custom") {
          this.sort = "total_custom_desc";
        } else if (event.prop == "total_point") {
          this.sort = "total_point_desc";
        } else if (event.prop == "custom_num") {
          this.sort = "custom_num_desc";
        }
        this.page = 1;
        this.getData();
      } else if (event.order == "ascending") {
        if (event.prop == "show_balance") {
          this.sort = "balance_asc";
        } else if (event.prop == "point") {
          this.sort = "point_asc";
        } else if (event.prop == "total_custom") {
          this.sort = "total_custom_asc";
        } else if (event.prop == "total_point") {
          this.sort = "total_point_asc";
        } else if (event.prop == "custom_num") {
          this.sort = "custom_num_asc";
        }
        this.page = 1;
        this.getData();
      } else if (event.order == null) {
        this.sort = "";
        this.page = 1;
        this.getData();
      }
    },
    // 点击行跳转用户详情
    rowClick(id) {
      this.$router.push({ path: "userDetail", query: { id: id } });
    },
    // 发送优惠券弹窗
    sendCouponFrom() {
      if (this.multipleSelection.length == 0) {
        this.$message("至少选择一个用户操作");
      } else {
        this.showSendCoupon = true;
      }
      // this.showSendCoupon = true;
    },
    getCommodUser(data) {
      console.log(data);
      this.sUserList = data;
      if (data.length > 5) {
        this.selectUserName =
          data[0].name +
          "," +
          data[1].name +
          "," +
          data[2].name +
          "," +
          data[3].name +
          "," +
          data[4].name +
          "等" +
          data.length +
          "位用户";
      } else {
        this.selectUserName =
          data.map((n) => n.name).join(",") + " 共" + data.length + "位用户";
      }
      this.showSelecterUser = false;
    },
    //选择优惠券 单张
    getCommodOne(data) {
      console.log(data);
      this.couponOne = data;
      this.showSelecterOne = false;
    }, //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除已选择优惠券
    delTagItem(i) {
      this.sList.splice(i, 1);
    },
    //发送
    clickSend() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        verification_code: this.code_num,
      };
      if (this.params.mobile != "") {
        data.mobile = this.params.mobile;
      }
      if (this.params.name != "") {
        data.name = this.params.name;
      }
      if (this.params.card_num != "") {
        data.card_num = this.params.card_num;
      }
      if (this.params.user_level_id) {
        data.user_level_id = this.params.user_level_id[1];
      }
      console.log("打印", this.params.user_level_id);
      // 時間篩選
      if (this.screen != "") {
        if (this.screen == "1") {
          data.start_time = this.formatTime(new Date(), 1);
          data.end_time = this.formatTime(new Date(), 2);
        }
        if (this.screen == "2") {
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          data.start_time = this.formatTime(start, 1);
          data.end_time = this.formatTime(start, 2);
        }
        if (this.screen == "7") {
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          data.start_time = this.formatTime(start, 1);
          data.end_time = this.formatTime(new Date(), 2);
        }
        if (this.screen == "z") {
          if (this.dateValue !== null && this.dateValue.length !== 0) {
            data.start_time = this.timeValue[0]
              ? this.dateValue[0] + " " + this.timeValue[0]
              : this.dateValue[0] + " 00:00:00";
            data.end_time = this.timeValue[1]
              ? this.dateValue[1] + " " + this.timeValue[1]
              : this.dateValue[1] + " 23:59:59";
          }
        }
      }
      if (this.no_custom_days != "") {
        data.no_custom_days = this.no_custom_days;
      }
      // data.uid = this.sUserList.map(item => item.id).join(',');
      data.uid = this.multipleSelection.map((item) => item.uid).join(",");

      if (this.sendToAll) {
        data.all = 1;
        data.type_method = 1;
        data.batch = "";
      }
      if (this.CouponType == "1") {
        data.id = this.sList.map((i) => i.id).join(",");
        console.log(data);
        this.startSendCoupon2(data);
        // sendCoupon(data).then(res => {
        //   if(res.code == 200){
        //     this.$message({
        //       type: "success",
        //       message: "发送成功"
        //     })
        //     this.closeSend();
        //   }else{
        //     this.$message({
        //       type: "error",
        //       message: res.msg
        //     })
        //   }
        // })
      } else {
        data.coupon_id = this.couponOne.id;
        data.num = this.everyoneNum;
        this.startSendCoupon(data);
      }
      this.sentPercent = 0;
      this.showSendPro = true;
    },
    startSendCoupon(data) {
      console.log("参数", data);
      var nextData = Object.assign({}, data);
      sendCouponS(data).then((res) => {
        if (res.code == 300) {
          //部分完成
          nextData.type_method = res.type_method;
          nextData.batch = res.batch;
          this.sentPercent = (Number(res.percent) * 100).toFixed(0);
          this.startSendCoupon(nextData);
        } else if (res.code == 200) {
          this.sentPercent = 100;
          this.$message({
            type: "success",
            message: "发送完成",
          });
          setTimeout(() => {
            this.showSendPro = false;
            this.showSendCoupon = false;
            this.sendToAll = false;
          }, 300);
        } else {
          this.$message(res.msg);
          setTimeout(() => {
            this.showSendPro = false;
          }, 300);
        }
      });
    },
    startSendCoupon2(data) {
      console.log("参数", data);
      var nextData = Object.assign({}, data);
      sendCoupon(data).then((res) => {
        if (res.code == 300) {
          //部分完成
          nextData.type_method = res.type_method;
          nextData.batch = res.batch;
          this.sentPercent = (Number(res.percent) * 100).toFixed(0);
          this.startSendCoupon2(nextData);
        } else if (res.code == 200) {
          this.sentPercent = 100;
          this.$message({
            type: "success",
            message: "发送完成",
          });
          setTimeout(() => {
            this.showSendPro = false;
            this.showSendCoupon = false;
            this.sendToAll = false;
          }, 300);
        } else {
          this.$message(res.msg);
          setTimeout(() => {
            this.showSendPro = false;
          }, 300);
        }
      });
    },
    //关闭发送优惠券窗口
    closeSend() {
      this.sList = [];
      this.sUserList = [];
      this.selectUserName = "";
      this.showSendCoupon = false;
      this.sendToAll = false;
      this.CouponType = "0";
    },
    // 打开调级窗口
    openChangeLevel() {
      if (this.multipleSelection.length == 0) {
        this.$message("至少选择一个用户操作");
      } else {
        this.showChangeLevel = true;
      }
    },
    // 调级保存
    clickChangeLevel() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        user_level_id: this.change_level_id,
        verification_code: this.code_num,
      };
      data.uids = this.multipleSelection.map((item) => item.uid).join(",");
      console.log(data);
      // return false;
      changeUserLevel(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.closeChange();
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 关闭调级弹窗
    closeChange() {
      this.change_level_id = "";
      this.showChangeLevel = false;
    },
    // 手机号查询
    searchMobile() {
      this.page = 1;
      this.getData();
    },
    // 用户油品订单
    showOrderMsg(id) {
      this.user_id_order = String(id);
      this.showOrderList = true;
    },
    // 用户充值订单
    showVoucherMsg(id) {
      this.user_id_voucher = id;
      this.showVoucherList = true;
    },
    // 导出
    exportList() {
      var param =
        "?token=" +
        this.token +
        "&app_id=" +
        this.app_id +
        "&point_order=" +
        this.sort +
        "&export_=1";
      if (this.params.mobile != "") {
        param += "&mobile=" + this.params.mobile;
      }
      if (this.params.name != "") {
        param += "&name=" + this.params.name;
      }
      if (this.params.card_num != "") {
        param += "&card_num=" + this.params.card_num;
      }
      if (this.params.user_level_id != "") {
        param += "&user_level_id=" + this.params.user_level_id;
      }

      var url1 =
        "https://www.58zltc.com/user/agent.User_level_card/index" + param;
      if (this.status == "test") {
        url1 = "https://cs.58zltc.com/user/agent.User_level_card/index" + param;
      }
      console.log(url1);
      // return false;
      window.location.href = url1;
      // let myObj = {
      //   method: 'get',
      //   url: url1,
      //   fileName: '会员列表',
      // }
      // exportMethod(myObj)
    },
    // 添加会员标签
    setUserTag() {
      this.selectUid = this.multipleSelection.map((x) => x.uid).join(",");
      console.log(this.selectUid);
      this.showUserTag = true;
    },
    closeTag(i) {
      this.showUserTag = false;
      if (i == 1) {
        this.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.date_picker_box {
  width: 140px;
}
.new_vip {
  padding: 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content {
    background: #fff;
    padding: 5px 20px;
    height: 100%;
    overflow: auto;
    .options {
      display: flex;
      line-height: 50px;
      height: 50px;
      margin-bottom: 10px;
      .options_item {
        margin-left: 12px;
      }
      .short_input {
        width: 52px;
      }
      .input_box {
        width: 80px;
      }
    }
    .stat_box {
      padding: 8px 0;
      background: #f1f2f6;
      margin: 0 -20px;
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      .stat_item_box {
        background: #fff;
        text-align: center;
        color: #666;
        .stat_item_title {
          height: 29px;
          line-height: 29px;
          border-bottom: 1px solid #f1f2f6;
          span {
            margin-left: 15px;
          }
        }
        .stat_item_value {
          line-height: 64px;
          font-size: 24px;
          span {
            font-size: 14px;
          }
        }
        .stat_item_cards {
          display: flex;
          padding-top: 10px;
          padding-bottom: 5px;
          .cards_item_box {
            flex: 1;
            position: relative;
          }
          .card_part_line {
            position: absolute;
            left: 0;
            top: 5px;
            bottom: 5px;
            width: 1px;
            border-left: 1px solid #eee;
          }
          .stat_item_cards_name {
            font-size: 12px;
          }
          .stat_item_cards_value {
            font-size: 24px;
            span {
              font-size: 14px;
            }
          }
        }
      }
      .stat_item_box_w {
        width: 33.1%;
      }
      .stat_item_box_w1 {
        width: 20%;
      }
      .stat_item_box_w2 {
        width: 59%;
      }
    }
    .button_line {
      line-height: 35px;
      display: flex;
      .button_left {
        flex: 1;
      }
      .button_right {
        margin-left: 10px;
      }
    }
    .table_content {
      flex: 1;
      margin-top: 15px;
      .headimg {
        width: 36px;
        height: 36px;
        img {
          width: 36x;
          height: 36px;
          border-radius: 18px;
        }
      }
    }
    .page {
      height: 30px;
      margin-top: 15px;
      text-align: right;
    }
  }
  .search_form_item {
    display: inline-block;
    width: 50%;
    .search_input {
      width: 214px;
    }
  }
  .search_button {
    margin-top: 15px;
    text-align: center;
  }
  .get-code {
    cursor: pointer;
  }
  .car_msg_box {
    display: flex;
    flex-wrap: wrap;
    .car_msg_item {
      width: 50%;
      line-height: 40px;
    }
  }
}
</style>
